import React, { Component } from "react";
import { Modal, Spin, Icon } from "antd";
import KeywordPositionChart from "./KeywordPositionChart";

class TrackedKeywordsChartModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  };

  handleOpenModal = _ => {
    this.props.fetchKeywordOverviews(this.props.domain, this.props.keyword, this.props.seoDb);
    this.toggleModal();
  };

  render() {
    return (
      <React.Fragment>
        {!this.props.isLoading ? (
          <span className="tracked-keywords-trend" onClick={this.handleOpenModal}>
            {this.props.openLabel}
          </span>
        ) : (
          <Spin style={{ lineHeight: "12px" }} indicator={<Icon type="loading" spin style={{ fontSize: 12 }} />} />
        )}
        {this.props.keywordOverviews ? (
          <Modal
            centered
            className="trend-chart-modal"
            title={this.props.modalTitle}
            visible={this.state.visible}
            onCancel={this.toggleModal}
            footer={null}>
            <KeywordPositionChart height={400} chartData={this.props.keywordOverviews} />
          </Modal>
        ) : null}
      </React.Fragment>
    );
  }
}

export default TrackedKeywordsChartModal;
